const config = {
	//"apiBase": '/'   //un comment for Server
    "apiBase": 'http://elan-api-dev.incedopay.com', //un comment for local 
    "base_url": `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
    "env": process.env.NODE_ENV || 'develop',
    }

export default config